import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/image/logo/trust_fund_title.svg'


const _hoisted_1 = { class: "nav-bar" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "title",
  class: "header-logo"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "sub-menu-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"width":"83px","margin-left":"10px"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"75px"} }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  style: {"position":"absolute","right":"1%","bottom":"0"},
  class: "version"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navBarMenu, (menu, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "menu-item"
        }, [
          (menu.subMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.subMenu, (subMenu, subIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: subIndex,
                    class: "sub-menu pointer-hover",
                    onClick: ($event: any) => (_ctx.routeNavbar(subMenu.route))
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(subMenu.title), 1)
                  ], 8, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ]))
      }), 128))
    ]),
    _createElementVNode("span", _hoisted_10, "v" + _toDisplayString(require("@/config").default.version), 1)
  ]))
}